import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { CaixaContext } from "../../../contexts/caixaContext";
import OpenedCaixa from "../OpenedCaixa";
import ClosedCaixa from "../ClosedCaixa";
import "../OpenedCaixa/modern-style.css";

const CaixaComponent = () => {
  const { t } = useTranslation('cashRegister');
  const { caixa, isLoading } = useContext(CaixaContext);

  if (isLoading) {
    return (
      <div className="modern-loading" style={{ minHeight: '60vh' }}>
        <div className="modern-loading-spinner"></div>
        <div className="modern-loading-text">{t('loading')}</div>
      </div>
    );
  }

  // If no caixa status (e.g. never opened), show closed view
  return <>{caixa.status === "open" ? <OpenedCaixa /> : <ClosedCaixa />}</>;
};

export default CaixaComponent;
